const endpoints = {
  WEBSOCKET_ADMIN_CREATE: '/v2/websocket/agent/adminCreate',
  CCP_FEATURE_SWITCHES: '/v2/ccp/whiteLabels/getFeatureSwitches',
  CCP_SET_FEATURE_SWITCH: '/v2/ccp/whiteLabels/setFeatureSwitch',
  CCP_ADMIN_GET_SETTING: '/v2/ccp/admin/getSetting',
  CCP_ADMIN_UPDATE_SETTING: '/v2/ccp/admin/updateSetting',
  CCP_STATS: '/v2/log/getStats',
  CCP_STATS_ARCHIVE: '/v2/log/stats/getArchive',
  CCP_STATS_DOWNLOAD_LINK: '/v2/log/stats/getDownloadLink',
  CCP_CONVERSATIONS_STATS: '/v2/log/getConversationsStats',
  CCP_AGENT_MESSAGES: '/v2/ccp/getAgentMessagesPreview',
  CCP_GET_AGENT_STATS: '/v2/log/getAgentStats',
  CCP_GET_RECURRING_CONVERSATIONS: '/v2/log/getRecurringConversations',
  CCP_GET_AGENT_SESSIONS: '/v2/log/getAgentSessions',
  MESSAGE_FILTERED_CONVERSATIONS: '/v2/message/getFilteredConversations',
  MESSAGE_CONVERSATION_DETAILS: '/v2/message/getConversationDetails',
  CCP_OBJECTIVES_LIST: '/v2/ccp/objectives/getAll',
  CCP_WHITELABELS_LIST: '/v2/ccp/agents/getWhiteLabels',
  AGENT_LIST: '/v2/ccp/agents/list',
  AGENT_CREATE: '/v2/ccp/agents/create',
  AGENT_FIND: '/v2/ccp/agents/find',
  AGENT_UPDATE: '/v2/ccp/agents/update',
  AGENT_ACTIVATE: '/v2/ccp/agents/activate',
  AGENT_DEACTIVATE: '/v2/ccp/agents/deactivate',
  AGENT_DELETE: '/v2/ccp/agents/delete',
  AGENT_RESTORE: '/v2/ccp/agents/restore',
  AGENT_DETACH_ALL: '/v2/ccp/agents/detachAll',
  AGENT_REMOVE_CONVERSATION: '/v2/ccp/agents/removeConversation',
  AGENT_FORCE_LOGOUT: '/v2/ccp/agents/forceLogout',
  PURGE_QUEUE: '/v2/ccp/admin/purgeQueue',
  GET_NICHES: '/v2/ccp/niches/getNiches',
  GET_NICHE_WHITE_LABELS: '/v2/ccp/niches/whiteLabels',
  ADD_NICHE: '/v2/ccp/niches/add',
  EDIT_NICHE: '/v2/ccp/niches/edit',
  GET_ASSIGNED_CAMPAIGNS: '/v2/ccp/agents/campaigns/list',
  ASSIGN_CAMPAIGN: '/v2/ccp/agents/campaigns/add',
  REMOVE_CAMPAIGN: '/v2/ccp/agents/campaigns/remove',
  GET_ASSIGNED_NICHES: '/v2/ccp/nicheMapping/getMapping',
  ASSIGN_NICHE_MAPPING: '/v2/ccp/nicheMapping/add',
  REMOVE_NICHE_MAPPING: '/v2/ccp/nicheMapping/remove',
  CLEAR_CACHE: '/v2/ccp/clearCache',
  GET_PERSONALITY_LIST: '/v2/ccp/personality/getList',
  REMOVE_PERSONALITY: '/v2/ccp/personality/remove',
  ASSIGN_PERSONALITY: '/v2/ccp/personality/add',
  OCBOTTEST_LIST_CONVERSATIONS: '/v2/ccp/ocBotTest/listConversations',
  OCBOTTEST_GET_CONVERSATION: '/v2/ccp/ocBotTest/getConversation',
  OCBOTTEST_GENERATE_RESPONSE: '/v2/ccp/ocBotTest/generateResponse',
}

export class Admin {

  constructor({ requester }) {
    this.requester = requester
    this.endpoints = endpoints
  }

  async authorize() {
    return this.requester.post(endpoints.WEBSOCKET_ADMIN_CREATE, {}, { excludeHeaders: ['x-safemode'] })
  }

  async getFeatureSwitches(opts) {
    return this.requester.get(endpoints.CCP_FEATURE_SWITCHES, {}, opts)
  }

  async setFeatureSwitch(data, opts) {
    return this.requester.post(endpoints.CCP_SET_FEATURE_SWITCH, data, opts)
  }

  async getSettings(groupName, opts) {
    return this.requester.get(endpoints.CCP_ADMIN_GET_SETTING, { groupName }, opts)
  }

  async updateSettings({ key, id, value }, opts) {
    return this.requester.post(endpoints.CCP_ADMIN_UPDATE_SETTING, { key, id, value }, opts)
  }

  async getStats(params, opts) {
    return this.requester.get(endpoints.CCP_STATS, params, opts)
  }

  async getRecurringConversations(params, opts) {
    return this.requester.get(endpoints.CCP_GET_RECURRING_CONVERSATIONS, params, opts)
  }

  async getAgentSessions(params, opts) {
    return this.requester.get(endpoints.CCP_GET_AGENT_SESSIONS, params, opts)
  }

  async getStatsArchive(params, opts) {
    return this.requester.get(endpoints.CCP_STATS_ARCHIVE, params, opts)
  }

  async getStatsDownloadLink(params, opts) {
    return this.requester.get(endpoints.CCP_STATS_DOWNLOAD_LINK, params, opts)
  }

  async getConversationsStats(params, opts) {
    return this.requester.get(endpoints.CCP_CONVERSATIONS_STATS, params, opts)
  }

  async getAgentMessages(params, opts =  {}) {
    return  this.requester.get(endpoints.CCP_AGENT_MESSAGES, params, opts)
  }

  async getAgentStats(params, opts) {
    return this.requester.get(endpoints.CCP_GET_AGENT_STATS, params, opts)
  }

  async getFilteredConversations(params, opts) {
    return this.requester.get(endpoints.MESSAGE_FILTERED_CONVERSATIONS, params, opts)
  }

  async getConversationDetails(conversationUid, params = {}, opts) {
    return this.requester.get(endpoints.MESSAGE_CONVERSATION_DETAILS, { conversationUid, ...params }, opts)
  }

  async listObjectives(opts) {
    return this.requester.get(endpoints.CCP_OBJECTIVES_LIST, {}, opts)
  }

  async listWhiteLabels(opts) {
    return this.requester.get(endpoints.CCP_WHITELABELS_LIST, {}, opts)
  }

  async listPersonalities(agentId, getAll, opts) {
    return this.requester.get(endpoints.GET_PERSONALITY_LIST, { agentId, getAll }, opts)
  }

  async removePersonality(agentId, personalityValue, opts) {
    return this.requester.post(endpoints.REMOVE_PERSONALITY, { agentId, personalityValue }, opts)
  }

  async assignPersonality(agentId, personalityValue, opts) {
    return this.requester.post(endpoints.ASSIGN_PERSONALITY, { agentId, personalityValue }, opts)
  }

  async listAgents(params, opts) {
    return this.requester.get(endpoints.AGENT_LIST, params, opts)
  }

  async create(newAgentData, opts) {
    return this.requester.post(endpoints.AGENT_CREATE, newAgentData, opts)
  }

  async find(id, view = 'public', opts) {
    return this.requester.get(endpoints.AGENT_FIND, { id, view }, opts)
  }

  async update(agent, opts) {
    return this.requester.post(endpoints.AGENT_UPDATE, { id: agent.id, data: agent }, opts)
  }

  async setActiveStatus(id, newStatus, opts) {
    return this.requester.post(newStatus ? endpoints.AGENT_ACTIVATE : endpoints.AGENT_DEACTIVATE, { id }, opts)
  }

  async delete(agentId, opts) {
    return  this.requester.post(endpoints.AGENT_DELETE, { agentId }, opts)
  }

  async restore(agentId, opts) {
    return this.requester.post(endpoints.AGENT_RESTORE, { agentId }, opts)
  }

  async detachAll(agentId, opts) {
    return this.requester.post(endpoints.AGENT_DETACH_ALL, { agentId }, opts)
  }

  async removeConversation(agentId, conversationUid, opts) {
    return this.requester.post(endpoints.AGENT_REMOVE_CONVERSATION, { agentId, conversationUid }, opts)
  }

  async forceFullyLogout(id, opts) {
    return this.requester.post(endpoints.AGENT_FORCE_LOGOUT, { id }, opts)
  }

  async purgeQueue(whiteLabelUids, opts) {
    return this.requester.post(endpoints.PURGE_QUEUE, whiteLabelUids ? { whiteLabelUids } : {}, opts)
  }

  async getNiches(name, opts) {
    return this.requester.get(endpoints.GET_NICHES, name ? { name } : {}, opts)
  }

  async getNicheWhiteLabels(nicheId, opts) {
    return this.requester.get(endpoints.GET_NICHE_WHITE_LABELS, nicheId ? { nicheId } : {}, opts)
  }

  async addNiche(name, opts) {
    return this.requester.post(endpoints.ADD_NICHE, name ? { name } : {}, opts)
  }

  async editNiche(id, name, opts) {
    return this.requester.post(endpoints.EDIT_NICHE, { id, name }, opts)
  }

  async getAssignedCampaigns(agentId, opts) {
    return this.requester.get(endpoints.GET_ASSIGNED_CAMPAIGNS, { agentId }, opts)
  }

  async assignCampaign(campaignId, agentId, opts) {
    return this.requester.post(endpoints.ASSIGN_CAMPAIGN, { campaignId, agentId }, opts)
  }

  async removeCampaign(campaignId, agentId, opts) {
    return this.requester.post(endpoints.REMOVE_CAMPAIGN, { campaignId, agentId }, opts)
  }

  async getAssignedNiches(agentId, opts) {
    return this.requester.get(endpoints.GET_ASSIGNED_NICHES, { agentId }, opts)
  }

  async assignNiche(agentId, nicheId, opts) {
    return this.requester.post(endpoints.ASSIGN_NICHE_MAPPING, { agentId, nicheId }, opts)
  }

  async removeNicheMapping(agentId, nicheId, opts) {
    return this.requester.post(endpoints.REMOVE_NICHE_MAPPING, { agentId, nicheId }, opts)
  }

  async clearCache() {
    return this.requester.post(endpoints.CLEAR_CACHE)
  }

  async listOcBotTestConversations(opts) {
    return this.requester.get(endpoints.OCBOTTEST_LIST_CONVERSATIONS, {}, opts)
  }

  async getOcBotTestConversation(data, opts) {
    return this.requester.post(endpoints.OCBOTTEST_GET_CONVERSATION, data, opts)
  }

  async generateOcBotTestResponse(data, opts) {
    return this.requester.post(endpoints.OCBOTTEST_GENERATE_RESPONSE, data, opts)
  }
}
